import { jwtDecode } from "jwt-decode"
import { useEffect, useMemo, useRef } from "react"
import { ActionType } from "../../../../lib/types"
import AuthFormAlert from "../../components/AuthFormAlert"
import AuthFormHeading from "../../components/AuthFormHeading"
import AuthMotion from "../../components/AuthMotion"
import loader from "./api/loader"

type AuthRequestLinkConfirmViewProps = ActionType &
  Awaited<ReturnType<typeof loader>>

const AuthRequestLinkConfirmView = ({
  token,
  error,
  onSubmit
}: AuthRequestLinkConfirmViewProps) => {
  const ref = useRef<HTMLButtonElement | null>(null)

  const { key: authRequestKey, sub: authRequestId } = useMemo(
    () => jwtDecode(token) as { key: string; sub: string },
    [token]
  )

  useEffect(() => {
    if (ref.current) {
      ref.current.click()
      ref.current = null
    }
  }, [ref])

  return (
    <AuthMotion>
      <form onSubmit={onSubmit}>
        <input
          hidden
          readOnly
          id="authRequestKey"
          name="authRequestKey"
          value={authRequestKey}
        />
        <input
          hidden
          readOnly
          id="authRequestId"
          name="authRequestId"
          value={authRequestId}
        />
        <button ref={ref} hidden />
        {error ? (
          <AuthFormAlert error={error} />
        ) : (
          <AuthFormHeading>Signing in...</AuthFormHeading>
        )}
      </form>
    </AuthMotion>
  )
}

export default AuthRequestLinkConfirmView
